import PropTypes from 'prop-types';
import React from 'react';
import { Link, generatePath } from 'react-router-dom';

import { unassignedPatientRoute } from 'App/common/routeLookup';
import AccordionWrapper from 'App/components/AccordionWrapper/AccordionWrapper';
import ManualPageTable from 'App/components/ManualPageTable';
import UtcDateCell from 'App/components/Table/Cells/UtcDateCell';
import useFetchAssociationQueue from '../../hooks/useFetchAssociationQueue';

const PatientIDLinkCell = ({ value, row }) => {
    return (
        <Link to={generatePath(unassignedPatientRoute, { associationQueueId: value })}>
            {row.original.message.ExternalId || '--'}
        </Link>
    );
};
PatientIDLinkCell.propTypes = {
    value: PropTypes.string.isRequired,
    row: PropTypes.shape({
        original: PropTypes.shape({
            message: PropTypes.shape({
                ExternalId: PropTypes.string,
            }),
        }),
    }).isRequired,
};

const columns = [
    {
        Header: 'Patient ID',
        accessor: 'uuid',
        Cell: PatientIDLinkCell,
    },
    {
        Header: 'Last Name',
        accessor: 'message.LastName',
    },
    {
        Header: 'First Name',
        accessor: 'message.FirstName',
    },
    {
        Header: 'Patient DOB',
        accessor: 'message.BirthDate',
        Cell: UtcDateCell,
    },
    {
        Header: 'Patient Zip',
        accessor: 'message.Location.Zip',
    },
    {
        Header: 'Status',
        accessor: () => 'Pending',
    },
];

const UnassignedPatientTable = () => {
    const { data } = useFetchAssociationQueue();
    const dataList = Object.values(data || {});

    if (dataList.length === 0) {
        return null;
    }

    return (
        <AccordionWrapper
            title={`Unassigned Patients (${dataList.length})`}
            stateKey="unassignedPatientActivity-toggle"
            defaultIsVisible={false}
        >
            <ManualPageTable columns={columns} data={dataList} pageSizeOptions={[]} />
        </AccordionWrapper>
    );
};

export default UnassignedPatientTable;
